import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ProfileImg from "../../Assets/Images/img2.png";
import { ButtonContainer } from "../Shared/ButtonComponent";

const MessagePopUp = () => {
  const [showPopUp, setShowPopUp] = useState(false);
  const closeModalHandler = () => setShowPopUp(false);
  return (
    <div>
      {" "}
      <Modal
        dialogClassName={"MessagePopUp"}
        show={showPopUp}
        onHide={closeModalHandler}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="message-header" closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal-title message-title"
          >
            <p>You have a pending Custom order</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="message-body">
          <div className="message_popup">
            {" "}
            <img src={ProfileImg} alt="" />
            <p>Click the button below to complete this custom order</p>
            <ButtonContainer>View to pay now</ButtonContainer>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button onClick={props.onHide}>Close</Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MessagePopUp;
